// Use generics to specify the type of the input and output arrays
function filterArray<TInput = any>(array: TInput[], filters: IFilters): TInput[] {
    const filterKeys = Object.keys(filters);
    return array.filter((item : any) => {
      // validates all filter criteria
      return filterKeys.every(key => {
        // ignores non-function predicates
        if (typeof filters[key] !== "function") return true;
        return filters[key](item[key]);
      });
    });
  }

// ignores case-sensitive
const getValue = (value: string) => (typeof value === 'string' ? value.toUpperCase() : value);



function filterPlainArray<TInput = any>(array: TInput[], filters: IFiltersArray): TInput[]  {
  const filterKeys = Object.keys(filters);
  return array.filter((item: any)=> {
    // validates all filter criteria
    return filterKeys.every(key => {
      // ignores an empty filter
      if (!filters[key].length) return true;
      return filters[key].find((filter: string) => getValue(filter) === getValue(item[key]));
    });
  });
}

// Define an interface for the filters object
interface IFilters {
    [key: string]: (value: any) => boolean;
}

interface IFiltersArray{
    [key: string]: string[];
}

export { filterArray, filterPlainArray}
   